// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(myChart, yearlist, data1, data2) {
  if (myChart) {
    myChart.clear();
  }
  if (data1.length > 0) {
    // 设置
    myChart.setOption({
      tooltip: {
        trigger: "item"
      },
      grid: {
        left: 20,
        top: 30,
        bottom: 30
      },
      xAxis: {
        data: yearlist,
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          interval: 0,
          textStyle: {
            color: "#fff",
            fontSize: 12
          },
          margin: 14 //刻度标签与轴线之间的距离。
        }
      },
      yAxis: {
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#fff",
            fontSize: 16
          }
        }
      },
      series: [
        {
          //三个最低下的圆片
          name: "",
          type: "pictorialBar",
          symbolSize: [60, 10],
          symbolOffset: [0, 5],
          z: 12,
          itemStyle: {
            opacity: 1,
            color: function(params) {
              var a = params.name;
              if (a === "2018") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#fdbc58" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fdbc58" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2019") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#1bbffb" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#1bbffb" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2020") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#73b7ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#73b7ff" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0367d8" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0367d8" // 100% 处的颜色
                    }
                  ],
                  false
                );
              }
            }
          },
          data: [1, 1, 1, 1]
        },

        //下半截柱状图
        {
          name: "",
          type: "bar",
          barWidth: 60,
          barGap: "-100%",
          itemStyle: {
            //lenged文本
            opacity: 0.7,
            color: function(params) {
              var a = params.name;
              if (a === "2018") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#fdb958" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fddf62" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2019") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#12b9fe" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#65f9f3" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2020") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#74baff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#679cff" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#014fce" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0dbefc" // 100% 处的颜色
                    }
                  ],
                  false
                );
              }
            }
          },

          data: data1
        },

        {
          // 替代柱状图 默认不显示颜色，是最下方柱图（邮件营销）的value值 - 20
          type: "bar",
          barWidth: 60,
          barGap: "-100%",
          stack: "广告",
          itemStyle: {
            color: "transparent"
          },
          data: data1
        },

        {
          name: "", //头部
          type: "pictorialBar",
          symbolSize: [60, 15],
          symbolOffset: [0, -10],
          z: 12,
          symbolPosition: "end",
          itemStyle: {
            color: function(params) {
              var a = params.name;
              if (a === "2018") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#cfae5a" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ae8853" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2019") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#1caae0" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#188abc" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2020") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#639fe2" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#4e82be" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0348b5" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0442a5" // 100% 处的颜色
                    }
                  ],
                  false
                );
              }
            },
            opacity: 1
          },

          data: data2
        },

        {
          name: "",
          type: "pictorialBar",
          symbolSize: [60, 10],
          symbolOffset: [0, -5],
          z: 12,
          itemStyle: {
            opacity: 1,
            color: function(params) {
              var a = params.name;
              if (a === "2018") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#faae57" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fdcc58" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2019") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0da7ec" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#43dff7" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2020") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#6aa4ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#6dabff" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0258d1" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#078ce8" // 100% 处的颜色
                    }
                  ],
                  false
                );
              }
            }
          },
          symbolPosition: "end",
          label: {
            normal: {
              show: true,
              position: "top",
              top: "-10%",
              // bottom: '-80%',
              fontSize: 16,
              // fontWeight: 'bold',
              fontFamily: "electronicFont",
              color: "#ffffff",
              formatter: "{c} (吨)"
            }
          },
          data: data1
        },

        {
          name: "",
          type: "bar",
          barWidth: 60,
          barGap: "-100%",
          z: 0,
          itemStyle: {
            color: function(params) {
              var a = params.name;
              if (a === "2018") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#6c5e4f" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#6c5e4f" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2019") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#136491" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#136491" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else if (a === "2020") {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#355f91" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#355f91" // 100% 处的颜色
                    }
                  ],
                  false
                );
              } else {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#07367d" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#07367d" // 100% 处的颜色
                    }
                  ],
                  false
                );
              }
            },
            opacity: 0.7
          },

          data: data2
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
